import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// The Pixel snippet in public/index.html only fires PageView once, on the
// initial document load — this SPA never reloads the page on navigation, so
// every route change after that needs its own explicit fire.
export default function MetaPixelRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return null;
}
